import request from "@/utils/request"
const projectUuids = ['06ddfe5e36f94a52861cea8d06f9b309','37fa59c63efd4b7ea3ae9cab75bae711']
// 实时温度
export function getRoomShowave(){
    return request({
        url: '/currentBigScreen/getRoomShowave',
        method: 'post',
        data: projectUuids
    })
}
// 能耗组成占比
export function getEnergyProportion() {
    return request({
        url: '/currentBigScreen/getEnergyProportion',
        method: 'post',
        data: projectUuids
    })
}
export function getEnergyChange() {
    return request({
        url: '/currentBigScreen/getEnergyChange',
        method: 'post',
        data: projectUuids
    })
}
// 冷间面积分布
export function getRoomArea() {
    return request({
        url: '/currentBigScreen/getRoomArea',
        method: 'post',
        data: projectUuids
    })
}
// 获取冷间运行时长
export function getRoomRunTime() {
    return request({
        url: '/currentBigScreen/getRoomRunTime',
        method: 'post',
        data: projectUuids
    })
}
// 查询项目城市当前温度湿度
export function getProjectWeatherData() {
    return request({
        url: '/currentBigScreen/getProjectWeatherData',
        method: 'get',
        params: {
            projectUuid: '06ddfe5e36f94a52861cea8d06f9b309'
        }
    })
}
// // 大屏简介
// export function getBriefIntroduction() {
//     return request({
//         url: '/currentBigScreen/getBriefIntroduction',
//         method: 'get',
//     })
// }